var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContinentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "world 1",
    clipPath: "url(#clip0_4872_41851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 0C10.57 0 9 1.57 9 3.5C9 5.296 11.808 8.477 12.128 8.834C12.223 8.939 12.358 9 12.5 9C12.642 9 12.777 8.939 12.872 8.834C13.192 8.477 16 5.296 16 3.5C16 1.57 14.43 0 12.5 0ZM12.5 5C11.672 5 11 4.328 11 3.5C11 2.672 11.672 2 12.5 2C13.328 2 14 2.672 14 3.5C14 4.328 13.328 5 12.5 5Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.7107 5.79434C8.4747 5.80534 8.2387 5.82434 7.9997 5.82434C7.1727 5.82434 6.3607 5.74734 5.5567 5.63434C5.2197 7.19634 5.2197 8.81234 5.5587 10.3743C7.1777 10.1483 8.8207 10.1483 10.4387 10.3743C10.5617 9.80634 10.6247 9.23034 10.6587 8.65334C10.0467 7.90334 9.2687 6.85834 8.7107 5.79434Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.5329 1.42111C8.3619 1.18811 8.1909 0.955109 7.9999 0.733109C6.9879 1.91111 6.2579 3.24411 5.81689 4.65111C6.6269 4.75811 7.4439 4.79911 8.2599 4.78611C8.0979 4.33611 7.9999 3.90011 7.9999 3.50011C7.9999 2.74611 8.2039 2.04611 8.5329 1.42111Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.41602 3.44C2.50702 3.92 3.64802 4.268 4.81402 4.495C5.30002 2.877 6.13602 1.344 7.31002 0C4.86602 0.21 2.73702 1.521 1.41602 3.44Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.186 11.5041C10.699 13.1231 9.86296 14.6561 8.68896 16.0001C11.134 15.7901 13.263 14.4791 14.584 12.5601C13.494 12.0791 12.352 11.7321 11.186 11.5041Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.8552 6.55481C15.0572 7.84581 14.0592 9.00881 13.6172 9.50181C13.3322 9.81782 12.9252 9.99982 12.5002 9.99982C12.1582 9.99982 11.8312 9.87782 11.5662 9.66582C11.5262 9.95382 11.4902 10.2418 11.4302 10.5268C12.6722 10.7728 13.8902 11.1468 15.0502 11.6648L15.1022 11.6878C15.6732 10.5828 16.0002 9.33081 16.0002 7.99981C16.0002 7.50481 15.9412 7.02481 15.8552 6.55481Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.81689 11.3493C6.2589 12.7563 6.9879 14.0893 7.9999 15.2673C9.0119 14.0893 9.7409 12.7553 10.1829 11.3483C8.7339 11.1573 7.2659 11.1583 5.81689 11.3493Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.81402 11.5041C3.64902 11.7321 2.50702 12.0791 1.41602 12.5601C2.73602 14.4791 4.86602 15.7901 7.31002 16.0001C6.13602 14.6561 5.29902 13.1231 4.81402 11.5041Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.567 5.47871C3.325 5.22971 2.115 4.85371 0.949 4.33471L0.898 4.31171C0.328 5.41671 0 6.66871 0 7.99971C0 9.33071 0.327 10.5827 0.898 11.6877L0.95 11.6647C2.111 11.1477 3.328 10.7737 4.569 10.5267C4.217 8.86271 4.216 7.14271 4.567 5.47871Z",
    fill: "#979EA8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_41851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinentIcon);
export default __webpack_public_path__ + "static/media/continentIcon.3e272a0124490d4a56d44723a634a1a8.svg";
export { ForwardRef as ReactComponent };